import { Link, useLocation } from 'react-router-dom';
import { Button, Result } from 'antd';

import { useAuth } from '../contexts/AuthContext';
import { getDefaultPostLoginRoute, isRouteAccessible } from '../config/panelMenuAccess';

/**
 * محافظ مسیر بر اساس تابع دسترسی.
 * @param {{ allow: (user: *) => boolean, children: import('react').ReactNode, title?: string }} props
 */
const RoleRoute = ({ allow, children, title = 'دسترسی مجاز نیست' }) => {
  const { user, loading } = useAuth();

  if (loading) return null;

  if (!user || !allow(user)) {
    const fallback = getDefaultPostLoginRoute({ user });
    return (
      <Result
        status="403"
        title={title}
        subTitle="شما مجوز دسترسی به این بخش را ندارید."
        extra={
          <Link to={fallback}>
            <Button type="primary">بازگشت به پنل</Button>
          </Link>
        }
      />
    );
  }

  return children;
};

/**
 * محافظ مسیر tenant بر اساس مجوزهای سازمان فعال و نقشه منو.
 */
export const TenantPermissionRoute = ({ children, title = 'دسترسی مجاز نیست' }) => {
  const { user, activeOrganization, organizations, loading } = useAuth();
  const location = useLocation();

  if (loading) return null;

  const ctx = { user, activeOrganization, organizations };
  if (!user || !isRouteAccessible(location.pathname, ctx)) {
    const fallback = getDefaultPostLoginRoute(ctx);
    return (
      <Result
        status="403"
        title={title}
        subTitle="شما مجوز دسترسی به این بخش را در سازمان فعال ندارید."
        extra={
          <Link to={fallback}>
            <Button type="primary">بازگشت به پنل</Button>
          </Link>
        }
      />
    );
  }

  return children;
};

export default RoleRoute;
